import { Button, Row, Col, Spin } from "antd";
import { useTranslation } from "react-i18next";

import { useEffect, useState } from "react";
import { ModalGraphics } from "./modal";
import dayjs from "dayjs";
import { TableDevice } from "./tableDevice";

import { Typography } from "antd";
import { Gauge } from "@ant-design/plots";
import useGaugeConfig from "../hooks/hook-gauge-config";

const { Title, Text } = Typography;

export const Measurement = ({ device, lastMeasurement, loadingMeasurement }) => {
  const { t } = useTranslation("global");
  const [dataModal, setDataModal] = useState({
    open: false,
    title: "",
    t,
    device,
    unit: "",
  });

  useEffect(() => {
    if (!device?.devEui) return;
    setDataModal((prev) => ({ ...prev, device }));
  }, [device]);

  const openModal = (fieldName, unit) => {
    setDataModal({
      ...dataModal,
      open: true,
      title: fieldName.replace(/_/g, " "),
      unit,
      measurement: fieldName,
    });
  };

  return (
    <div>
      <TableDevice t={t} dataTable={[device]}></TableDevice>

      <Spin spinning={loadingMeasurement}>
        <Row wrap={true} gutter={[16, 16]}>
          {lastMeasurement.map((item) => (
            <ItemCardMeasurement
              key={item.field}
              t={t}
              devEui={device.devEui}
              measurementName={item.field}
              title={item.field.replace(/_/g, " ")}
              unit={item.unit}
              value={item.value}
              status={item.status}
              date={item.timestamp}
              isOpenModal={() => openModal(item.field, item.unit)}
            />
          ))}
        </Row>
      </Spin>
      <ModalGraphics dataModal={dataModal} setDataModal={setDataModal} />
    </div>
  );
};

const ItemCardMeasurement = ({
  t,
  devEui,
  measurementName,
  title,
  unit,
  value,
  status,
  date,
  isOpenModal,
}) => {
  const { config, loading } = useGaugeConfig(devEui, measurementName, value, unit);
  const color = status === "FAIL" ? { color: "#ffab66" } : { color: "#39C337" };

  return (
    <Col span={8} xs={24} sm={24} md={12} lg={8}>
      <div className="item-measurements" style={{ padding: '20px', textAlign: 'center', height: '100%' }}>
        <h3>{title}</h3>

        <div style={{ height: '200px', marginBottom: '10px' }}>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Spin size="small" />
            </div>
          ) : config ? (
            <Gauge {...config} height={200} />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <h2>
                {value} {unit}
              </h2>
            </div>
          )}
        </div>

        <div style={{ marginTop: '10px' }}>
          <Text>{dayjs(date).format("DD-MM-YYYY HH:mm")}</Text>
          <Title level={4} style={{ ...color, margin: '8px 0' }}>
            {status === "FAIL" ? t("metrics.outOfRange") : "OK"}
          </Title>

          <div>
            <Button type="primary" shape="round" onClick={isOpenModal}>
              {t("metrics.showMore")}
            </Button>
          </div>
        </div>
      </div>
    </Col>
  );
};
